<template>
  <div :id="comment.id" class="gmf-comment gmf-comment-oneliner" :class="{'gmf-comment-reply': depth > 0, 'gmf-comment-final': finalNode, 'gmf-comment-collapse': collapse}">
    <div class="gmf-comment-indent"
      v-for="i in depth"
      :key="i"
      :class="{
        'gmf-comment-indent-nested': i > 1,
        'gmf-comment-branch': parentBranches && parentBranches[i-1],
        'gmf-comment-leaf': i === depth,
      }"
    />
    <div class="gmf-comment-customer-col">
      <Avatar disablePopout :customer="comment.author" />
    </div>
    <div class="gmf-comment-content-col">
      <div class="gmf-comment-content">
        <div class="gmf-comment-header" @click="$emit('expand')">
          <div class="gmf-comment-name">{{ customerName }}</div>
          <div class="gmf-comment-text" v-if="text && text.length > 0" v-text="text" />
        </div>
      </div>
    </div>
    <div class="gmf-clearfix" />
  </div>
</template>

<style>
.gmf-comment-oneliner .gmf-comment-header {
  white-space: nowrap;
  display: flex;
  margin-bottom: 0;
  cursor: pointer;
  align-items: center;
  flex-direction: row;
}
.gmf-comment-oneliner .gmf-comment-header:hover {
  text-decoration: underline;
}
.gmf-comment-oneliner .gmf-comment-text {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 2px;
}
.gmf-comment-oneliner .gmf-comment-content-col {
  margin-bottom: 0;
  margin-top: 0;
}
.gmf-comment-oneliner .gmf-comment-customer-col, .gmf-sp .gmf-comment-oneliner .gmf-comment-customer-col {
  width: 24px !important;
  padding: var(--gmf-p-3) 0;
  padding-left: var(--gmf-p-1);
}
.gmf-comment-oneliner .gmf-avatar {
  width: 24px;
  height: 24px;
  background: none !important;
}
.gmf-comment-oneliner .gmf-avatar-content {
  border-radius: 0px;
}
.gmf-comment-oneliner .gmf-comment-content-col, .gmf-comment-oneliner .gmf-comment-customer-col {
  align-self: center;
}
.gmf-comment-oneliner .gmf-comment-leaf::after {
  height: 22px;
}
</style>

<script>
/* eslint-disable vue/no-mutating-props */

import state from '@/state';
import Avatar from '@/components/Avatar';

const t = state.t.prefix('comments');


export default {
  props: ['compact', 'collapse', 'comment', 'depth', 'finalNode', 'parentBranches', 'voteMode', 'showDelete', 'deleteMethod', 'targetId', 'description', 'elements'],
  data () {
    return {
      showCompactReplies: true,
      isCompact: this.compact,
      state,
      isReplying: false,
    };
  },
  components: {
    Avatar,
  },
  computed: {
    commentType () {
      return this.comment.type.name;
    },
    shouldTranslate() {
      return this.state.merchantConfig.widgets?.translations?.mode === 'autoTranslateAndOriginalButton';
    },
    commentTypeConfig () {
      const c = this.state.merchantConfig?.comments || {};
      return c[this.commentType] || {};
    },
    text () {
      let text = this.comment.content.text;

      if (this.comment && this.comment?.translation && this.shouldTranslate) {
        text = this.comment.translation.text;
      }

      text = text.replace(/\s+/g, ' ');

      return text;
    },
    customerName () {
      if (this.comment.author.firstName && this.comment.author.firstName.length > 0) {
        return this.comment.author.firstName;
      }
      return t('anonymous');
    },
    profile() {
      return this.state.profile;
    }
  },
  methods: {
    t,
  },
};
</script>
